<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="props.detailData.platform_name + ' 备用金明细记录'" width="80%" :open="true"
        :confirmLoading="state.loading" :maskClosable="false" @ok="onFormSubmit" @cancel="cancel" :footer="null">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="5" :sm="24">
                            <a-form-item label="类型" name="type">
                                <a-select mode="multiple" v-model:value="queryParam.type" placeholder="请选择">
                                    <a-select-option :value="1">收入</a-select-option>
                                    <a-select-option :value="2">支出</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="5" :sm="24">
                            <a-form-item label="关联行为" name="source_type">
                                <a-select mode="multiple" v-model:value="queryParam.source_type" placeholder="请选择">
                                    <a-select-option :value="1">入账备用金</a-select-option>
                                    <a-select-option :value="2">报销</a-select-option>
                                    <a-select-option :value="3">发佣金</a-select-option>
                                    <a-select-option :value="4">发推荐奖励</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="5" :sm="24">
                            <a-form-item label="创建时间">
                                <BetweenTimePick v-model:value="queryParam.between_time"></BetweenTimePick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="5" :sm="24">
                            <a-form-item label="备注">
                                <a-input v-model:value="queryParam.remark" placeholder="备注"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="3" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                                <a-divider type="vertical" />
                                <a-button type="primary" @click="handleOperate">操作</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'index'">
                        {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
                    </template>
                    <template v-else-if="column.dataIndex === 'type'">
                        <a-tag v-if="record.type == 1" color="green">收入</a-tag>
                        <a-tag v-if="record.type == 2" color="blue">支出</a-tag>
                    </template>
                    <template v-else-if="column.dataIndex === 'attachment'">
                        <template v-for="(item, index) in record.attachment">
                            <a-image
                                v-if="item.url.endsWith('png') || item.url.endsWith('jpg') || item.url.endsWith('jpeg')"
                                :width="60" :height="60" :key="index"
                                :src="$store.state.user.image_domain + item.url"></a-image>
                            <a :href="$store.state.user.image_domain + item.url" target="_blank" v-else>
                                {{ item.name }}
                            </a>
                        </template>
                    </template>
                    <template v-else-if="column.dataIndex === 'operate'">
                        <a @click="showAllAttach(record)">更多附件</a>
                    </template>
                </template>
            </a-table>
            <pettycashOperate v-if="state.operateVisible" @cancel="handleCancel" @ok="handleOk"
                :detailData="props.detailData">
            </pettycashOperate>
            <pettycashAttach v-if="state.attachVisible" @cancel="handleCancel" @ok="handleOk"
                :detailData="state.detailData">
            </pettycashAttach>
        </a-card>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import BetweenTimePick from '@/components/base/BetweenTimePick.vue'
import pettycashOperate from './pettycashOperate.vue'
import pettycashAttach from './pettycashAttach.vue'
const emit = defineEmits(['ok', 'cancel'])
import { useStore } from 'vuex'
const $store = useStore()
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const columns = [
    {
        title: '序号',
        dataIndex: 'index',
        width: 60
    },
    {
        title: '类型',
        dataIndex: 'type',
        width: 100
    },
    {
        title: '变更前',
        dataIndex: 'balance_before',
        width: 100
    },
    {
        title: '发生金额',
        dataIndex: 'amount',
        width: 100
    },
    {
        title: '变更后',
        dataIndex: 'balance_after',
        width: 100
    },
    {
        title: '流水发生时间',
        dataIndex: 'amount_time',
        width: 200
    },
    {
        title: '经手人',
        dataIndex: 'operator_name',
        width: 200
    },
    {
        title: '经手时间',
        dataIndex: 'created_at',
        width: 200
    },
    {
        title: '关联行为',
        dataIndex: 'source_type_name',
        width: 200
    },
    {
        title: '备注',
        dataIndex: 'remark',
        width: 200
    },
    {
        title: '附件',
        dataIndex: 'attachment',
        width: 200
    },
    {
        title: '操作',
        dataIndex: 'operate',
        width: 200
    }
]
interface state {
    loading: boolean
    detailData: object
    operateVisible: boolean
    attachVisible: boolean
}
const state = reactive<state>({
    loading: false,
    detailData: {},
    operateVisible: false,
    attachVisible: false
})
let queryParam = reactive<any>({
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/pettycash/loglist',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, petty_cash_id: props.detailData.id }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.total_records
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const onFormSubmit = () => {
    emit('cancel')
}
const cancel = () => {
    emit('cancel')
}
const handleOperate = (record) => {
    state.operateVisible = true
}
const showAllAttach = (record) => {
    state.attachVisible = true
    state.detailData = { ...record }
}
const handleCancel = () => {
    state.operateVisible = false
    state.attachVisible = false
}
const handleOk = () => {
    state.operateVisible = false
    state.attachVisible = false
    loadData()
}
</script>
<style lang="less" scoped></style>
